export const SET_DYNAMIC_PAGINATION = 'SET_DYNAMIC_PAGINATION';

export function setDynamicPagination(dynamicPagination) {
  return {
    type: SET_DYNAMIC_PAGINATION,
    dynamicPagination,
  };
}
